import { IStore } from '../../../index'

function getNotificationsNotSeenCount(state: IStore) {
  return state.userAccount.notifications.countNotSeen
}

function getNotificationsNotReadCount(state: IStore) {
  return state.userAccount.notifications.countNotRead
}

function getNotificationsCount(state: IStore) {
  return state.userAccount.notifications.count
}

function getNotificationSeen(state: IStore) {
  return state.userAccount.notifications.seen
}

export {
  getNotificationsNotReadCount,
  getNotificationsNotSeenCount,
  getNotificationsCount,
  getNotificationSeen,
}
